import React from 'react';
import { MuiTelInput, matchIsValidTel } from 'mui-tel-input';

/**
 * International phone input (country + number). Value is stored/sent as E.164 (e.g. +14155552671).
 */
export function PhoneNumberField({
  label = 'Phone',
  value,
  onChange,
  defaultCountry = 'US',
  margin = 'normal',
  fullWidth = true,
  helperText,
  error,
  disabled,
  required,
  sx,
  ...rest
}) {
  return (
    <MuiTelInput
      {...rest}
      fullWidth={fullWidth}
      label={label}
      value={value || ''}
      onChange={onChange}
      defaultCountry={defaultCountry}
      margin={margin}
      helperText={helperText}
      error={error}
      disabled={disabled}
      required={required}
      sx={sx}
    />
  );
}

export { matchIsValidTel };

export default PhoneNumberField;
